// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function() {
    var header = document.querySelector('.main-header-wrapper');
    if (!header) return;

    function handleScroll() {
        // Skip scroll logic while mobile menu is open to prevent layout conflicts
        if (document.body.classList.contains('menu-is-open')) return;

        var topBar = document.querySelector('.top-bar');
        var wpAdminBar = document.getElementById('wpadminbar');
        var topBarHeight = topBar ? topBar.offsetHeight : 0;
        var currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        if (currentScroll > topBarHeight) {
            if (!header.classList.contains('is-sticky')) {
                header.classList.add('is-sticky');
            }
            document.body.style.paddingTop = header.offsetHeight + 'px';

            // Calculate dynamic top offset in case the admin bar scrolls out of view on mobile
            var adminBarOffset = 0;
            if (wpAdminBar) {
                var rect = wpAdminBar.getBoundingClientRect();
                adminBarOffset = Math.max(0, rect.bottom);
            }
            header.style.top = adminBarOffset + 'px';
        } else {
            if (header.classList.contains('is-sticky')) {
                header.classList.remove('is-sticky');
            }
            document.body.style.paddingTop = '0px';
            header.style.top = '';
        }
    }

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    handleScroll(); // Initial run


    // Make parent dropdown links clickable on desktop screens
    var dropdownLinks = document.querySelectorAll('.navbar-nav .dropdown-toggle');
    dropdownLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            if (window.innerWidth >= 1200) {
                var href = this.getAttribute('href');
                if (href && href !== '#' && href !== '') {
                    window.location.href = href;
                }
            }
        });
    });

    // Handle full-screen mobile menu overlay state toggles
    var togglers = document.querySelectorAll('.col-widgets .navbar-toggler');
    var closeButton = document.querySelector('.mobile-menu-overlay .menu-close');
    var overlay = document.querySelector('.mobile-menu-overlay');

    if (togglers && overlay) {
        togglers.forEach(function(toggler) {
            toggler.addEventListener('click', function(e) {
                e.preventDefault();
                // Dynamically calculate top offset based on admin bar visibility in viewport
                var wpAdminBar = document.getElementById('wpadminbar');
                var overlayTop = 0;
                if (wpAdminBar) {
                    var adminRect = wpAdminBar.getBoundingClientRect();
                    overlayTop = Math.max(0, adminRect.bottom);
                }
                overlay.style.top = overlayTop + 'px';
                overlay.classList.add('is-active');
                document.body.classList.add('menu-is-open');
            });
        });
    }

    if (closeButton && overlay) {
        closeButton.addEventListener('click', function(e) {
            e.preventDefault();
            overlay.classList.remove('is-active');
            document.body.classList.remove('menu-is-open');
            // Restore correct sticky/scroll state after menu closes
            handleScroll();
        });
    }

    // High-Contrast Mode persistence and toggling
    var currentContrastMode = localStorage.getItem('contrastMode');

    function syncContrastIcons(action) {
        var contrastIcons = document.querySelectorAll('.contrast-icon');
        contrastIcons.forEach(function(icon) {
            if (action === 'add') {
                icon.classList.add('is-reversed');
            } else {
                icon.classList.remove('is-reversed');
            }
        });
    }

    function enableContrastMode() {
        document.body.classList.add('contrast-mode');
        syncContrastIcons('add');
        localStorage.setItem('contrastMode', 'enabled');
    }

    function disableContrastMode() {
        document.body.classList.remove('contrast-mode');
        syncContrastIcons('remove');
        localStorage.setItem('contrastMode', 'disabled');
    }

    if (currentContrastMode === 'enabled') {
        enableContrastMode();
    }

    var contrastButtons = document.querySelectorAll('.contrast-toggle-btn');
    contrastButtons.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
            e.preventDefault();
            if (document.body.classList.contains('contrast-mode')) {
                disableContrastMode();
            } else {
                enableContrastMode();
            }
        });
    });


    // A+ Font Resizing System
    var htmlElement = document.documentElement;

    function applyFontSize(sizeClass) {
        htmlElement.classList.remove('font-size-lg', 'font-size-xl');
        var label = 'A+';

        if (sizeClass === 'lg') {
            htmlElement.classList.add('font-size-lg');
            localStorage.setItem('fontSizePreference', 'lg');
            label = 'A++';
        } else if (sizeClass === 'xl') {
            htmlElement.classList.add('font-size-xl');
            localStorage.setItem('fontSizePreference', 'xl');
            label = 'A+++';
        } else {
            localStorage.setItem('fontSizePreference', 'normal');
        }

        // Synchronize all instances of the toggle button on the page
        var fontToggleBtns = document.querySelectorAll('.font-resize-toggle-btn');
        fontToggleBtns.forEach(function(btn) {
            btn.textContent = label;
        });
    }

    var savedSize = localStorage.getItem('fontSizePreference');
    if (savedSize) {
        applyFontSize(savedSize);
    } else {
        // Enforce default labels on initial page load
        applyFontSize('normal');
    }

    // Add click listener that cycles through the sizes and updates all instances
    document.addEventListener('click', function(e) {
        var btn = e.target.closest('.font-resize-toggle-btn');
        if (btn) {
            e.preventDefault();
            if (htmlElement.classList.contains('font-size-lg')) {
                applyFontSize('xl');
            } else if (htmlElement.classList.contains('font-size-xl')) {
                applyFontSize('normal');
            } else {
                applyFontSize('lg');
            }
        }
    });


    // Mobile Footer Accordion (Screens < 767px)
    if (window.innerWidth < 767) {
        jQuery('.footer-links-col .widget-title').on('click', function() {
            var $title = jQuery(this);
            var $widget = $title.parent('.widget');
            
            $widget.toggleClass('is-open');
            $title.siblings().slideToggle(300);
        });
    }
});